module.exports = __webpack_public_path__ + "img/room-size.8c72a012.svg";